import React from "react";
import Button from "../Button/Button";
import "./Smallscreens.scss";
import Logo from "../../assets/LAETUS.png";

const Smallscreens = () => {
	return (
		<div className="smallscreens">
			<div>
				<h1>OUPS,VOUS ETES SUREMENT SUR MOBILE </h1>
				<p>
					La création de campagne est actuellement accessible par PC uniquement.
				</p>
				<br />

				<Button
					text="Retourner sur LAETUS"
					onClick={() =>
						(window.location.href = "https://www.laetus-store.com/")
					}
					className="screen-btn"
				/>
			</div>
		</div>
	);
};
export default Smallscreens;
